import React, { useContext, useEffect, useState } from 'react';
import {
  initialValues,
  validationSchema,
} from './config/closeWorkOrderFormConfig';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import ReportIssueError from '../../../../reportissue/components/ReportIssueError';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AppInfoContext, UserContext } from '../../../../../../App';
import { ClipLoader } from 'react-spinners';
import FormikCustomSelect from '../../reportproblem/components/FormikCustomSelect';
import DateTimePickerForm from '../date-time/DateTimePickerForm';
import ServiceType from './selectoptions/ServiceType';
import LocationComponent from '../../reportproblem/components/selectOptions/LocationComponent';
import WorkLogCard from './WorkLogCard';
import WorkLogModal from './WorkLogModal';
import SelectWorker from './SelectWorker';
import './WorkOrderForm.css';
import './CloseWorkOrder.css';
import SelectEquipment from './SelectEquipment';
import ExternalServices from './ExternalServices';
import SelectMaterial from './SelectMaterial';
import SewerageType from './selectoptions/SewerageType';
import SewerageActivity from './selectoptions/SeverageActivity';
import WsActivity from './selectoptions/wsActivity';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

const fetchProblemDetails = async (id, token) => {
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const response = await fetch(`${apiUrl}/problems/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return response.json();
};

const fetchWorkOrderDetails = async (id, token) => {
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const response = await fetch(`${apiUrl}/work-orders/${id}/problem`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return response.json();
};

export default function CloseWorkOrder({ setFormInfo, setFormStep }) {
  const { userDetails } = useContext(UserContext);
  const { appInformation, setAppInformation } = useContext(AppInfoContext);

  const token = localStorage.getItem('token');
  const problemId = appInformation.problemManagement.id;

  const [internalStep, setInternalStep] = useState(0);

  const [showWorkLogModal, setShowWorkLogModal] = useState(false);

  const [workers, setWorkers] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [externalServices, setExternalServices] = useState([]);

  const [activeItem, setActiveItem] = useState(null);

  const [totalExpense, setTotalExpense] = useState(0);

  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const { data } = useQuery(
    ['problemDatils', problemId],
    () => fetchProblemDetails(problemId, token),
    {
      enabled: !!problemId,
    },
  );

  const { data: workOrderDetails } = useQuery(
    ['workOrderDatils', problemId],
    () => fetchWorkOrderDetails(problemId, token),
    {
      enabled: !!problemId,
    },
  );
  const [submittingForm, setSubmittingForm] = useState(false);

  const reloadData = () => {
    const currentZoom = window.map.getView().getZoom();
    window.map.getView().setZoom(currentZoom + 0.0001);
  };

  const onSubmit = (values, onSubmitProps) => {
    setSubmittingForm(true);
    closeWorkOrderMutate(values);
  };

  const { mutate: closeWorkOrderMutate } = useMutation({
    mutationFn: (closeWorkOrderData) =>
      fetch(`${apiUrl}/closed-work-orders`, {
        method: 'POST',
        body: JSON.stringify({
          ...closeWorkOrderData,
          note: closeWorkOrderData.note === '' ? null : closeWorkOrderData.note,
          user: userDetails,
          issueId: data?.issue?.id,
          workOrder: workOrderDetails,
          workOrderEquipment: equipment,
          workOrderUsers: workers,
          externalService: externalServices,
          workOrderMaterial: materials,
          totalExpense: Math.floor(totalExpense * 1000) / 1000,
          wsActivity:
            closeWorkOrderData.wsActivity === ''
              ? null
              : closeWorkOrderData.wsActivity,
          sewerageType:
            closeWorkOrderData.sewerageType ===
            LocationComponent.NEPOZNATO.value
              ? null
              : closeWorkOrderData.sewerageType === ''
                ? null
                : closeWorkOrderData.sewerageType,
          sewerageActivity:
            closeWorkOrderData.sewerageActivity ===
            LocationComponent.NEPOZNATO.value
              ? null
              : closeWorkOrderData.sewerageActivity === ''
                ? null
                : closeWorkOrderData.sewerageActivity,
          elementType:
            closeWorkOrderData.locationComponent ===
            LocationComponent.NEPOZNATO.value
              ? null
              : appInformation.problemManagement.selectedLayer,
          elementId:
            closeWorkOrderData.locationComponent ===
            LocationComponent.NEPOZNATO.value
              ? null
              : parseInt(appInformation.problemManagement.selectedElement, 10),
          geom: appInformation.problemManagement.location
            ? {
                type: 'Point',
                coordinates: [
                  appInformation.problemManagement.location.x,
                  appInformation.problemManagement.location.y,
                ],
              }
            : null,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        setSubmittingForm(false);
        window.popup.hide();
        setFormInfo((prevValue) => ({
          ...prevValue,
          workOrder: { formType: 'close', formSubmissionAccepted: true },
        }));
        setFormStep(7);
        reloadData();
        return;
      }
      setFormInfo((prevValue) => ({
        ...prevValue,
        workOrder: { formType: 'close', formSubmissionAccepted: false },
      }));
      window.popup.hide();
      setFormStep(7);
    },
    onError: (error) => {
      console.log('error', error);
      setFormInfo((prevValue) => ({
        ...prevValue,
        workOrder: { formType: 'close', formSubmissionAccepted: false },
      }));
      setSubmittingForm(false);
      window.popup.hide();
      setFormStep(7);
    },
  });

  const [workLogModalType, setWorkLogModalType] = useState(null);

  const handleShowWorkLogModal = (workLogModalType) => {
    setWorkLogModalType(workLogModalType);
    setShowWorkLogModal(true);
  };

  const closeShowWorkLogModal = () => {
    setShowWorkLogModal(false);
  };

  const handleItemListRemoval = (type, itemId) => {
    subtractTotalExpense(type, itemId);

    setActiveItem(null);
    if (type === 'workers')
      setWorkers(workers.filter((worker, index) => index !== itemId));
    else if (type === 'materials')
      setMaterials(materials.filter((material, index) => index !== itemId));
    else if (type === 'equipment')
      setEquipment(equipment.filter((equip, index) => index !== itemId));
  };

  const subtractTotalExpense = (type, itemId) => {
    setTotalExpense(
      (prevTotal) =>
        prevTotal -
        parseFloat(
          type === 'workers'
            ? (workers[itemId].currentHourlyRate / 60) * workers[itemId].minutes
            : type === 'materials'
              ? materials[itemId].currentPriceRate *
                materials[itemId].usedQuantity
              : equipment[itemId].vehicle
                ? (equipment[itemId].currentPriceRate / 60) *
                  equipment[itemId].amount
                : equipment[itemId].tool.rateType === 1
                  ? equipment[itemId].currentPriceRate *
                    equipment[itemId].amount
                  : (equipment[itemId].currentPriceRate / 60) *
                    equipment[itemId].amount,
        ),
    );
  };

  const showLocationModal = () => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      problemManagement: {
        ...prevValue.problemManagement,
        locationModal: true,
      },
    }));
  };

  const setLayerSelection = (selectedLayerType) => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      problemManagement: {
        ...prevValue.problemManagement,
        elementSelection: true,
        selectedLayer: selectedLayerType,
      },
    }));
  };

  const resetLayerSelection = () => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      problemManagement: {
        ...prevValue.problemManagement,
        elementSelection: false,
        selectedLayer: null,
        selectedElement: null,
      },
    }));
  };

  const isMobile = useIsMobile();

  const waterSystemElements = Object.values(LocationComponent).map(
    (type) => type.value,
  );
  const sewerageTypes = Object.values(SewerageType).map((type) => type.value);
  const sewerageActivities = Object.values(SewerageActivity).map(
    (type) => type.value,
  );

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnChange={false}
      >
        {(formik) => {
          const fieldValidation = (fieldName) => {
            formik.validateField(fieldName);
          };

          const convertSelectValueToNumber = (fieldName, e) => {
            formik.setFieldValue(fieldName, parseInt(e.target.value, 10));

            if (fieldName === 'serviceType') {
              formik.setFieldValue('locationComponent', '');
              formik.setFieldValue('sewerageType', '');
              formik.setFieldValue('wsActivity', '');
              formik.setFieldValue('sewerageActivity', '');
              resetLayerSelection();
            }

            if (fieldName === 'locationComponent') resetLayerSelection();

            if (
              formik.values.serviceType === 1 &&
              fieldName === 'locationComponent'
            ) {
              formik.setFieldValue('sewerageType', '');
              formik.setFieldValue('sewerageActivity', '');
            }
          };

          const setFormDate = (dateTimePickerField, date) => {
            formik.setFieldValue(dateTimePickerField, date);
          };

          return (
            <Form>
              <div>
                <div
                  style={{
                    paddingBottom: '5px',
                    height:
                      internalStep === 0 && !isMobile
                        ? '461px'
                        : internalStep === 1 && 'auto',
                    width: internalStep === 0 && isMobile && '80vw',
                  }}
                  className="work-order-form-body"
                >
                  {internalStep === 0 && (
                    <>
                      <div>
                        <FormikCustomSelect
                          selectLabel={'Tip usluge'}
                          selectName={'serviceType'}
                          selectList={ServiceType}
                          validateSelection={() =>
                            fieldValidation('serviceType')
                          }
                          convertSelectValueToNumber={
                            convertSelectValueToNumber
                          }
                        />
                        {formik.values.serviceType !== '' && (
                          <>
                            <div className="wo-form-field-container">
                              <FormikCustomSelect
                                selectLabel={'Pozicija'}
                                selectName={'locationComponent'}
                                selectList={LocationComponent}
                                validateSelection={() =>
                                  fieldValidation('locationComponent')
                                }
                                convertSelectValueToNumber={
                                  convertSelectValueToNumber
                                }
                                selectFilter={(() => [
                                  ...(formik.values.serviceType ===
                                  ServiceType.VODOVOD.value
                                    ? waterSystemElements.slice(0, 15)
                                    : waterSystemElements.slice(
                                        15,
                                        waterSystemElements.length,
                                      )),
                                  waterSystemElements.length - 1,
                                ])()}
                              />
                            </div>
                            {formik.values.serviceType === 0 && (
                              <>
                                <div className="wo-form-field-container">
                                  <FormikCustomSelect
                                    selectLabel={'Aktivnost održavanja'}
                                    selectName={'wsActivity'}
                                    selectList={WsActivity}
                                    validateSelection={() =>
                                      fieldValidation('wsActivity')
                                    }
                                    convertSelectValueToNumber={
                                      convertSelectValueToNumber
                                    }
                                  />
                                </div>
                              </>
                            )}
                            {formik.values.serviceType === 1 &&
                              formik.values.locationComponent !== '' &&
                              formik.values.locationComponent !==
                                LocationComponent.NEPOZNATO.value && (
                                <>
                                  <div className="wo-form-field-container">
                                    <FormikCustomSelect
                                      selectLabel={'Vrsta kanalizacije'}
                                      selectName={'sewerageType'}
                                      selectList={SewerageType}
                                      validateSelection={() =>
                                        fieldValidation('sewerageType')
                                      }
                                      convertSelectValueToNumber={
                                        convertSelectValueToNumber
                                      }
                                      selectFilter={
                                        [
                                          LocationComponent.KANALIZACIONACIJEV
                                            .value,
                                          LocationComponent.KANALIZACIONISAHT
                                            .value,
                                        ].includes(
                                          formik.values.locationComponent,
                                        )
                                          ? sewerageTypes.slice(0, 3)
                                          : sewerageTypes.slice(3, 5)
                                      }
                                    />
                                  </div>

                                  <div className="wo-form-field-container">
                                    <FormikCustomSelect
                                      selectLabel={'Aktivnost održavanja'}
                                      selectName={'sewerageActivity'}
                                      selectList={SewerageActivity}
                                      validateSelection={() =>
                                        fieldValidation('sewerageActivity')
                                      }
                                      convertSelectValueToNumber={
                                        convertSelectValueToNumber
                                      }
                                      selectFilter={(() => [
                                        ...(formik.values.locationComponent ===
                                        LocationComponent.KANALIZACIONACIJEV
                                          .value
                                          ? sewerageActivities.slice(0, 9)
                                          : formik.values.locationComponent ===
                                              LocationComponent
                                                .KANALIZACIONISAHT.value
                                            ? sewerageActivities.slice(9, 16)
                                            : sewerageActivities.slice(
                                                16,
                                                sewerageActivities.length - 1,
                                              )),
                                        sewerageActivities.length - 1,
                                      ])()}
                                    />
                                  </div>
                                </>
                              )}
                          </>
                        )}

                        <DateTimePickerForm
                          dateTimePickerLabel={'Period početka radova'}
                          dateTimePickerName={'startDate'}
                          dateValue={formik.values.startDate}
                          setFormDate={setFormDate}
                          validateDate={() => fieldValidation('startDate')}
                        />

                        <DateTimePickerForm
                          dateTimePickerLabel={'Period završetka radova'}
                          dateTimePickerName={'endDate'}
                          dateValue={formik.values.endDate}
                          setFormDate={setFormDate}
                          validateDate={() => fieldValidation('endDate')}
                        />

                        <div className="wo-form-field-container">
                          <label htmlFor="note" className="wo-form-label">
                            Napomena
                          </label>
                          <Field
                            as="textarea"
                            id="note"
                            name="note"
                            className="work-order-form-field wo-form-textarea"
                          />
                          <ErrorMessage
                            name="note"
                            component={ReportIssueError}
                          />
                        </div>
                      </div>
                      <div className="close-work-order-report-buttons">
                        <div className="close-work-order-report-container">
                          <label htmlFor="report" className="wo-form-label">
                            Izvještaj
                          </label>
                          <Field
                            as="textarea"
                            id="report"
                            name="report"
                            className="work-order-form-field wo-form-textarea wo-work-details close-work-order-report-textarea"
                          />
                          <ErrorMessage
                            name="report"
                            component={ReportIssueError}
                          />
                        </div>

                        <div className="close-work-order-buttons close-work-order-buttons-mobile">
                          <button
                            className="close-work-order-button-form"
                            onClick={() => setFormStep(6)}
                          >
                            Učitaj datoteke
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              formik.validateForm().then((errors) => {
                                formik.setTouched({
                                  serviceType: true,
                                  startDate: true,
                                  endDate: true,
                                  locationComponent: true,
                                  report: true,
                                });
                                if (Object.keys(errors).length > 0) {
                                } else {
                                  setInternalStep(1);
                                }
                              })
                            }
                            className="close-work-order-button-form close-work-order-next-step-button close-work-order-green-button "
                          >
                            Sljedeći korak
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {internalStep === 1 && (
                    <div>
                      <div className="worklog-cards">
                        <WorkLogCard
                          title={'Radna snaga'}
                          items={workers}
                          type="workers"
                          handleShowWorkLogModal={handleShowWorkLogModal}
                          activeItem={activeItem}
                          setActiveItem={setActiveItem}
                          handleItemListRemoval={handleItemListRemoval}
                        />

                        <WorkLogCard
                          title={'Mehanizacija, oprema i vozila'}
                          items={equipment}
                          type="equipment"
                          handleShowWorkLogModal={handleShowWorkLogModal}
                          activeItem={activeItem}
                          setActiveItem={setActiveItem}
                          handleItemListRemoval={handleItemListRemoval}
                        />

                        <div>
                          <WorkLogCard
                            title={'Potrošni materijal i dijelovi'}
                            items={materials}
                            type="materials"
                            handleShowWorkLogModal={handleShowWorkLogModal}
                            activeItem={activeItem}
                            setActiveItem={setActiveItem}
                            handleItemListRemoval={handleItemListRemoval}
                          />

                          <button
                            type="button"
                            className="close-work-order-button-form"
                            onClick={() =>
                              handleShowWorkLogModal('externalServices')
                            }
                          >
                            Usluge trećih lica
                          </button>
                        </div>
                      </div>

                      {showWorkLogModal && (
                        <WorkLogModal
                          title={
                            workLogModalType === 'workers'
                              ? 'Radna snaga'
                              : workLogModalType === 'equipment'
                                ? 'Mehanizacija, oprema i vozila'
                                : workLogModalType === 'materials'
                                  ? 'Potrošni materijal i dijelovi'
                                  : 'Usluge trećih lica'
                          }
                          bodyComponent={
                            workLogModalType === 'workers' ? (
                              <SelectWorker
                                workers={workers}
                                setWorkers={setWorkers}
                                setTotalExpense={setTotalExpense}
                                closeShowWorkLogModal={closeShowWorkLogModal}
                              />
                            ) : workLogModalType === 'equipment' ? (
                              <SelectEquipment
                                equipment={equipment}
                                setEquipment={setEquipment}
                                setTotalExpense={setTotalExpense}
                                closeShowWorkLogModal={closeShowWorkLogModal}
                              />
                            ) : workLogModalType === 'materials' ? (
                              <SelectMaterial
                                materials={materials}
                                setMaterials={setMaterials}
                                setTotalExpense={setTotalExpense}
                                closeShowWorkLogModal={closeShowWorkLogModal}
                              />
                            ) : (
                              <ExternalServices
                                externalServices={externalServices}
                                setExternalServices={setExternalServices}
                                setTotalExpense={setTotalExpense}
                                closeShowWorkLogModal={closeShowWorkLogModal}
                              />
                            )
                          }
                          closeShowWorkLogModal={closeShowWorkLogModal}
                        />
                      )}

                      <div className="close-work-order-button-group">
                        <button
                          type="button"
                          className="close-work-order-button-form"
                          onClick={() => setInternalStep(0)}
                        >
                          Nazad
                        </button>
                        <button
                          type="button"
                          className="close-work-order-button-form"
                          onClick={() => showLocationModal()}
                          style={{
                            backgroundColor: !appInformation.problemManagement
                              .location
                              ? '#21538f'
                              : '#079c6a',
                          }}
                        >
                          Nova lokacija
                        </button>

                        <button
                          type="button"
                          className="close-work-order-button-form"
                          disabled={
                            formik.values.locationComponent ===
                            LocationComponent.NEPOZNATO.value
                          }
                          onClick={() =>
                            setLayerSelection(
                              Object.values(LocationComponent).find(
                                (locationComponent) =>
                                  locationComponent.value ===
                                  formik.values.locationComponent,
                              )?.layerName,
                            )
                          }
                          style={{
                            backgroundColor:
                              formik.values.locationComponent ===
                              LocationComponent.NEPOZNATO.value
                                ? 'gray'
                                : !appInformation.problemManagement
                                      .selectedElement
                                  ? '#21538f'
                                  : '#079c6a',
                            cursor:
                              formik.values.locationComponent ===
                                LocationComponent.NEPOZNATO.value && 'default',
                          }}
                        >
                          Poveži element
                        </button>

                        <button
                          type="submit"
                          className="close-work-order-button-form close-work-order-green-button"
                          style={{
                            backgroundColor:
                              !appInformation.problemManagement.selectedLayer &&
                              !appInformation.problemManagement
                                .selectedElement &&
                              formik.values.locationComponent !==
                                LocationComponent.NEPOZNATO.value &&
                              'gray',
                            cursor:
                              !appInformation.problemManagement.selectedLayer &&
                              !appInformation.problemManagement
                                .selectedElement &&
                              formik.values.locationComponent !==
                                LocationComponent.NEPOZNATO.value &&
                              'default',
                          }}
                          disabled={
                            submittingForm ||
                            (formik.values.locationComponent !==
                              LocationComponent.NEPOZNATO.value &&
                              !appInformation.problemManagement.selectedLayer &&
                              !appInformation.problemManagement.selectedElement)
                          }
                        >
                          {submittingForm ? (
                            <ClipLoader
                              color={'white'}
                              loading={submittingForm}
                              size={20}
                              data-testid="loader"
                            />
                          ) : (
                            'Zatvori nalog'
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {internalStep === 0 && (
                  <div className="close-work-order-buttons close-work-order-buttons-desktop">
                    <button
                      className="close-work-order-button-form"
                      onClick={() => setFormStep(6)}
                    >
                      Učitaj datoteke
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        formik.validateForm().then((errors) => {
                          formik.setTouched({
                            serviceType: true,
                            sewerageActivity: true,
                            sewerageType: true,
                            wsActivity: true,
                            startDate: true,
                            endDate: true,
                            locationComponent: true,
                            report: true,
                          });
                          if (Object.keys(errors).length > 0) {
                          } else {
                            setInternalStep(1);
                          }
                        })
                      }
                      className="close-work-order-button-form close-work-order-next-step-button close-work-order-green-button "
                    >
                      Sljedeći korak
                    </button>
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
